import { apiClient } from '@/shared/lib/api/client';
import type { RelogioResponse, VersaoApiResponse } from '@/types/api';

export const sistemaService = {
  obterRelogio: async (): Promise<RelogioResponse> => {
    const { data } = await apiClient.get<RelogioResponse>('/v1/sistema/relogio');
    return data;
  },
  obterVersao: async (): Promise<VersaoApiResponse> => {
    const { data } = await apiClient.get<VersaoApiResponse>('/v1/sistema/versao');
    return data;
  },
};
